import React from "react";
import { CheckboxColumnValue, ColumnValueRendererProps } from "../table.data.interface";
import { Check } from "@vibe/icons";

const CheckboxColumn = ({ columnData, otherBoardsValues }: ColumnValueRendererProps) => {
  if (
    columnData.value === "Empty Column" ||
    !columnData?.value ||
    (!columnData?.value && otherBoardsValues)
  ) {
    return null;
  }

  const value = otherBoardsValues
    ? (columnData?.value as CheckboxColumnValue)?.checked
    : columnData?.value;

  return <div>{value ? <Check size={20} color="#00c875" /> : ""}</div>;
};

export default CheckboxColumn;
